var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _vm.mmtoken && !_vm.isOffline
      ? _c("div", { ref: "postList", staticClass: "c-flex" }, [
          _c(
            "div",
            [
              _vm._l(_vm.pinnedPostIds, function (pid) {
                return _c(
                  "div",
                  { key: pid, staticClass: "mb-3" },
                  [
                    _vm.posts[pid].showMenu
                      ? _c("channel-post-menu", {
                          attrs: { post: _vm.posts[pid], "likes-only": true },
                          on: {
                            like: function ($event) {
                              return _vm.reactToPost($event, "heart")
                            },
                            thumbsup: function ($event) {
                              return _vm.reactToPost($event, "+1")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card bg-light mb-1 c-border-radius-25" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex card-body",
                            on: {
                              click: function ($event) {
                                return _vm.onPostClick(pid, $event)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "avatar",
                              attrs: {
                                src: _vm.avatars[_vm.posts[pid].user_id],
                                alt: _vm.avatars[_vm.posts[pid].username],
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grow-1 ms-2" },
                              [
                                _c("div", [
                                  _c("div", [
                                    _vm.users[_vm.posts[pid].user_id]
                                      ? _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.userFullName(pid)) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFormatedDate(
                                              _vm.posts[pid].create_at
                                            )
                                          )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "c-post",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.convert2Html(_vm.posts[pid].message)
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.postImages[pid], function (image) {
                                  return _c("img", {
                                    key: image.src,
                                    staticClass: "img-thumbnail c-post-img",
                                    attrs: { src: image.src, alt: image.name },
                                  })
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    pid in _vm.postReactions
                      ? _c(
                          "div",
                          _vm._l(_vm.postReactions[pid], function (v, k) {
                            return _c(
                              "button",
                              {
                                key: k,
                                staticClass:
                                  "btn btn-sm btn-outline-light me-1",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.reactToPost(pid, k)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { color: "black" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.emojis[k] || k) +
                                        " " +
                                        _vm._s(v.size)
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                !_vm.showAll
                  ? _c(
                      "span",
                      {
                        staticClass: "btn",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.showAll = true
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-chevron-down" })]
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ])
      : _vm.isOffline
      ? _c("div", { staticClass: "text-center card bg-light" }, [_vm._m(0)])
      : _c("div", { staticClass: "text-center card bg-light" }, [_vm._m(1)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("h3", [_vm._v("Keine Serververbindung")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("h3", [
        _c("a", { attrs: { href: "/accounts/login?next=/" } }, [
          _vm._v("Login"),
        ]),
        _vm._v(" erforderlich, um den "),
        _c("b", [_vm._v("Activity-Stream")]),
        _vm._v(" anzeigen zu können."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }